import { c as _c } from "react/compiler-runtime";
import { ContextMenu, ContextMenuItem } from '@repo/design-system/components/ui/context-menu';
import { useT } from '@repo/i18n/components/i18n.client';
interface FogContextMenuProps {
  x: number;
  y: number;
  onReset: () => void;
  onClose: () => void;
}
export const FogContextMenu = t0 => {
  const $ = _c(17);
  const {
    x,
    y,
    onReset,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[1] !== onReset) {
    t2 = details => {
      if (details.value === "reset-fog") {
        onReset();
      }
    };
    $[1] = onReset;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClose) {
    t3 = details_0 => {
      if (!details_0.open) {
        onClose();
      }
    };
    $[3] = onClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== x || $[6] !== y) {
    t4 = {
      x,
      y
    };
    $[5] = x;
    $[6] = y;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <ContextMenuItem value="reset-fog" leadingIcon="restart_alt" destructive={true}>{t5}</ContextMenuItem>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <ContextMenu open={true} closeOnSelect={false} onSelect={t2} onOpenChange={t3} anchorPoint={t4}>{t6}</ContextMenu>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
function _temp($) {
  return $.layer_fog_of_war_reset;
}